module.exports = __webpack_public_path__ + "static/media/Institution_Engineers_NUS.7b55daff.jpg";